/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProductB2BPriceAdvantageQueryVariables = Types.Exact<{
  modelId: Types.Scalars['BigInteger']['input'];
  platform: Types.Platform;
}>;

export type ProductB2BPriceAdvantageQuery = { __typename?: 'Query' } & {
  priceAdvantage: Types.Maybe<
    { __typename?: 'PriceAdvantage' } & Pick<
      Types.PriceAdvantage,
      'amountSaved' | 'amountSavedPercentage'
    >
  >;
};

export const ProductB2BPriceAdvantageDocument = /*#__PURE__*/ `
    query ProductB2BPriceAdvantage($modelId: BigInteger!, $platform: Platform!) {
  priceAdvantage(modelId: $modelId, platform: $platform) {
    amountSaved
    amountSavedPercentage
  }
}
    `;

export function useProductB2BPriceAdvantageQuery(
  options: Omit<
    Urql.UseQueryArgs<ProductB2BPriceAdvantageQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ProductB2BPriceAdvantageQuery,
    ProductB2BPriceAdvantageQueryVariables
  >({ query: ProductB2BPriceAdvantageDocument, ...options });
}
